module.exports = __webpack_public_path__ + "img/28.f9a6d69f.jpg";